import React from "react";

const DEFAULT_ITEMS = [
  "RONALDINHO",
  "C. RONALDO",
  "A. ROBBEN",
  "KAKÁ",
  "R. NAZÁRIO",
  "ZIDANE",
  "MARADONA",
  "PELÉ",
];

export default function TickerMarquee({ items = DEFAULT_ITEMS, variant = "rust" }) {
  const bg = variant === "gold" ? "bg-[#C8A96A] text-[#0F0C0B]" : "bg-[#613123] text-[#F2EBDD]";
  const sep = variant === "gold" ? "text-[#0F0C0B]" : "text-[#C8A96A]";
  const doubled = [...items, ...items, ...items];

  return (
    <div
      data-testid="ticker-marquee"
      className={`${bg} overflow-hidden border-y border-[#332D2B] py-3`}
    >
      <div className="ticker-track font-mono-retro text-sm tracking-[0.25em] uppercase">
        {doubled.map((item, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6">
            <span>{item}</span>
            <span className={sep}>★</span>
          </span>
        ))}
      </div>
    </div>
  );
}
